import React from 'react';

import { Typography, Grid, Box, Container } from "@mui/material";

import PRINCIPALIMAGE from '../../assets/RR_Software_SlideAB.png'

const DistributionChart = () => {
    const chartTitleStyle = { color: 'grey', fontWeight: 'bold', fontSize: '18px', margin: '0.2em', marginTop: '1em' }

    return <Grid container>
        <Box xs={10} ml={5} style={{ display: 'flex', flexDirection: 'row',  marginLeft: '10%' }}  >
            <Typography style={chartTitleStyle}> WHEN YOU ARE DISTRIBUTING MONEY, </Typography>
            <Typography style={{ ...chartTitleStyle, color: '#157ee8', textDecoration: 'underline', cursor: 'pointer' }} id={"link-button"} > THE SEQUENCE OF RETURNS MEANS EVERYTHING </Typography>
        </Box>
        <Grid container  justifyContent={'center'}>
            <Grid item xs={10} >
            <img src={PRINCIPALIMAGE} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </Grid>
        </Grid>
        <Box xs={10} ml={5} style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em', marginLeft: '10%' }}  >
            <Typography style={{ ...chartTitleStyle, fontSize: '16px' }}> End Result: During Distribution  </Typography>
            <Typography style={{ ...chartTitleStyle, fontSize: '16px', color: '#157ee8', textDecoration: 'underline', cursor: 'pointer' }} id={"link-button"} > The Sequence of Returns Will Significantly Affect Your Final Account Value </Typography>
            <Typography style={{ ...chartTitleStyle, fontSize: '16px' }}> and Potentially Cause You to Run Out of Money</Typography>
        </Box>
    </Grid>
}

export default DistributionChart;
